var React = require('react');

function HamburgerInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"HamburgerIcon","key":0},"Hamburger icon"),React.createElement("desc",{"id":"ExpandHamburger","key":1},"An icon that expands the menu options"),React.createElement("path",{"d":"M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z","fill":"#323232","key":2})]);
}

HamburgerInline.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = HamburgerInline;

HamburgerInline.default = HamburgerInline;
